import { ref } from 'vue'

const i = ref(1)

export default function get(prefix = 'holo-id'): string {
  i.value += 1

  return `${prefix}-${i.value}`
}
